import { useSelector } from 'hooks/utils';
import { selectFormsMapByProjectId } from 'store/data/forms';

export function useFormsMap() {
	return useSelector(state => selectFormsMapByProjectId(state.data.forms));
}
